'use strict';

$('.change-sub-category').on('click', function () {
    var categoryName = $(this).attr('sub-category');
    var category = $('.all-categories').find(`.${categoryName}`);

    $(this).addClass('active-btn');
    $(this).siblings('.change-sub-category').removeClass('active-btn');

    category.addClass('active');
    category.siblings('.category-part ').removeClass('active');
});

$('#categories').on('change', function () {
    var categoryName = document.querySelector('#categories').value;
    var category = $('.all-categories').find(`.${categoryName}`);

    category.addClass('active');
    category.siblings('.category-part ').removeClass('active');
});
